import './index.less';

//checkApp 为全局的 app 对象，checkApp.core 包括了核心 api 
const { Feature, meta, hook, event } = checkApp.core;//eslint-disable-line
const { Tooltip, Button } = checkApp.components;//eslint-disable-line
const { utils } = checkApp.common;//eslint-disable-line

const promotionList = window._promotion || [{
  suffix: 'com',
  price: 353,
  type: 'bundle',
  value: 'host',
  name: '+独享云虚拟主机经济版 (年)',
  description: '独立IP，不限流量，建站首选！',
  link: '',
  display: true
}, {
  suffix: 'com',
  price: 18.6,
  type: 'bundle',
  value: 'dns',
  name: '+云解析经济版 (年)',
  description: '独立IP，不限流量，建站首选！',
  link: '',
  display: true
}, {
  suffix: 'cn',
  price: 18.6,
  type: 'bundle',
  value: 'dns',
  name: '+云解析经济版 (年)',
  description: '独立IP，不限流量，建站首选！',
  link: '',
  display: true
}, {
  suffix: 'com',
  price: 0,
  type: 'domain',
  valueTemplate: '{keyword}.xyz',
  name: '免费送同名 xyz',
  description: '注册 .com，免费送同名 xyz',
  link: '',
  display: 'added',
  auto: true
}];

//通过继承 Featrue 实现一个扩展
//meta 用于描述插件的名称、依赖及权重
@meta('promotionFeature', ['cart'], 99999)
export default class PromotionFeature extends Feature {

  findPromotions(item) {
    return promotionList.filter(promotion => {
      let matched = promotion.suffix == item.suffix;
      if (matched) promotion.item = item;
      this.parsePromotion(promotion);
      return matched;
    });
  }

  @hook('checkItem.check')
  async checkItem(item) {
    if (item.avail != 1) return;
    item.matchedPromotions = this.findPromotions(item);
    await this.checkState();
  }

  parsePromotion(promotion) {
    let tmpValue = promotion.valueTemplate;
    if (!tmpValue) return;
    utils.each(promotion.item, (key, value) => {
      if (key == 'item') return;
      tmpValue = tmpValue.replace(`{${key}}`, value);
    });
    const { keyword } = this.getState();
    tmpValue = tmpValue.replace('{keyword}', keyword);
    promotion.value = tmpValue;
  }

  async isAdded(promotion) {
    return (await this.cart.has(promotion));
  }

  async isVisible(promotion) {
    return promotion.display === true || promotion.display === 'true' ||
      (promotion.display == 'added' && await this.isAdded(promotion));
  }

  @event('cart.change')
  async checkState() {
    await Promise.all(promotionList.map(promotion => {
      return (async () => {
        promotion.added = await this.isAdded(promotion);
        promotion.visible = await this.isVisible(promotion);
      })();
    }));
    await this.setState({ promotionList }, { scoped: true });
  }

  @event('cart.add')
  addToCart(event) {
    const changeList = event.detail;
    changeList.forEach(domain => {
      promotionList.filter(p => p.item.domain == domain).forEach(promotion => {
        if (!promotion || !promotion.auto) return;
        this.cart.add(promotion);
      });
    });
  }

  renderPromotions(item) {
    const { matchedPromotions } = item;
    return matchedPromotions.map((promotion, index) => (
      <li key={index} style={{ display: promotion.visible === false ? 'none' : 'block' }}>
        <Tooltip trigger={
          <a className="info" href={promotion.link || 'javascript:;'}>
            <span className="subject">{promotion.name}</span>
            <span className="price">￥{promotion.price}</span>
          </a>
        }>{promotion.description}</Tooltip>
        <Button type="light" shape="ghost" size="small"
          onClick={() => this.toggle(promotion)}>
          {promotion.added ? '移出清单' : '加入清单'}
        </Button>
      </li>
    ));
  }

  async toggle(promotion) {
    if (await this.cart.has(promotion)) {
      this.cart.remove(promotion);
    } else {
      if (!(await this.cart.has(promotion.item))) {
        await this.cart.add(promotion.item);
      }
      await this.cart.add(promotion);
    }
  }

  @hook('checkItem.renderAttach')
  renderAttach(item, prevResult) {//eslint-disable-line
    if (!item.matchedPromotions || item.matchedPromotions.length < 1) {
      return prevResult;
    }
    return <div key={item.domain} className="attach">
      <ul className="promotion">{this.renderPromotions(item)}</ul>
    </div>;
  }

}


// WEBPACK FOOTER //
// ./src/promotion/index.js